
import { Component, Vue } from 'vue-property-decorator';

import Form20ProcessHeader from "@/components/process/Form20/components/Form20ProcessHeader.vue";
import Form20StyleOfProceeding from "@/components/process/Form20/components/Form20StyleOfProceeding.vue";
import { form20StatusInfoType } from '@/types/Information/Form20';

@Component({
    components:{
        Form20ProcessHeader,        
        Form20StyleOfProceeding
    }
})
export default class FillForm20 extends Vue {

    stepsCompleted = {} as form20StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
